var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview"},[_c('div',{staticClass:"preview__header"},[_c('Dashboard',{attrs:{"team":_vm.team}}),_vm._t("default")],2),_c('Scene',{attrs:{"activeTheme":_vm.activeTheme,"slideTypes":_vm.slideTypes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }